<template>
  <v-app-bar
    id="maropost-app"
    app
    clipped-left
    clipped-right
    color="primary"
    tag="header"
    light
  >
    <v-app-bar-nav-icon color="white" @click.stop="toggleDrawer" slot="default">
      <v-icon color="white"> mdi-menu </v-icon>
    </v-app-bar-nav-icon>

    <v-toolbar-title class="mr-12 align-center overflow-visible">
      <!-- @todo change to route to dashboard once dashboard view have been created -->
      <router-link class="text-decoration-none" :to="$paths.customers">
        <div class="mt-1 d-flex align-center">
          <v-img
            alt="Inboxaware nav logo"
            :src="$vuetify.breakpoint.smAndDown ? $images.navHeaderMobileLogo : $images.inboxAwareNavHeaderLogo"
          />
          <v-divider
            vertical
            color="white"
            id="header-divider"
            class="mx-4 white"
          />
          <small
            class="white--text secondary--font text-uppercase font-weight-large subtitle-1"
          >
            Admin Panel
          </small>
        </div>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <v-menu offset-y :value="isMenuOpen" @input="isMenuOpen = !isMenuOpen">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            text
            id="top-right__dropdown"
            class="text-capitalize text-spaced--0 pl-4 pr-3"
          >
            <v-icon medium class="pr-1" color="white">
              mdi-account-circle
            </v-icon>
            <span
              class="d-none d-sm-flex white--text subtitle-2 secondary--font font-weight-large"
            >
              {{ userFullName }}
            </span>
            <v-icon color="white">
              {{ menuIcon }}
            </v-icon>
          </v-btn>
        </template>
        <v-list class="w-100 py-1" dense>
          <v-list-item-group color>
            <v-list-item
              link
              dense
              @click="logout"
              class="px-5 text-black--80"
              style="min-height: 36px !important"
            >
              <v-list-item-icon class="mr-2">
                <v-icon v-text="logoutAction.icon" class="text-dark-grey" />
              </v-list-item-icon>
              <v-list-item-content
                class="pl-3 text-capitalize body-2 text--primary"
              >
                {{ logoutAction.name }}
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
/**
 * ---------------- App Header ------------------
 */
export default {
  name: "AppHeader",
  /**
   * ---------------- Data properties ------------------
   */
  data() {
    return {
      logoutAction: {
        name: "Logout",
        icon: "mdi-logout",
        to: "logout",
      },
      isMenuOpen: false,
    };
  },
  /**
   * ------------------- Methods ---------------------
   */
  methods: {
    /**
     * Maps store action
     */
    ...mapActions({
      logoutUser: "auth/logoutUser",
    }),
    /**
     * Dispatches an action in the store to logout the user
     */
    logout() {
      this.logoutUser();
    },
    /**
     * Toogle drawer
     * @emits toggle-drawer
     */
    toggleDrawer() {
      this.$emit("toggle-drawer");
    },
  },
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    ...mapGetters({
      userProfile: "auth/currentUserProfile",
    }),
    /**
     * Full name of logged in user
     */
    userFullName() {
      const { userProfile } = this;
      return `${userProfile?.first_name ?? ""} ${userProfile?.last_name ?? ""}`;
    },
    /**
     * Dropdown menu icon on the basis of menu is opened or not
     */
    menuIcon() {
      return this.isMenuOpen ? "mdi-menu-up" : "mdi-menu-down";
    },
  },
};
</script>

<style lang="scss">
#maropost-app {
  z-index: 20 !important;
}
#header-divider {
  width: 2px !important;
  height: 24px !important;
}
</style>
